<!--
 * @Author: Dzy
 * @Date: 2022-07-14 09:48:26
 * @LastEditors: Dzy
 * @LastEditTime: 2023-02-20 14:54:57
 * @Description: 基础样式配置
-->
<template>
  <a-config-provider :locale="LOCAL">
    <!-- <a-config-provider :locale="zh_TW"> -->
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view>
  </a-config-provider>
</template>
<script setup>
import zh_CN from 'ant-design-vue/es/locale/zh_CN'
import zh_TW from 'ant-design-vue/es/locale/zh_TW'
import en_US from 'ant-design-vue/es/locale/en_US'
import dayjs from 'dayjs'
import { onBeforeMount, watch, ref, computed, onMounted } from 'vue'
import { QINIU_BASE_URL } from './Constants'
import { storeToRefs } from 'pinia'
import useStore from '@/store'
import useQueryIcon from '@com-common/useQueryIcon.js'
import { useI18n } from 'vue-i18n'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { useRouter } from 'vue-router'
import { setLanguageHeader } from '@/utils/request'
import useBuildUinfos from '@com/auth/useBuildUinfos'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'
const router = useRouter()
const { auth, config, userToken } = useStore()
const { getUinfoByToken } = useBuildUinfos(auth, userToken)

const { loadSimpleInfo } = useQueryIcon()
const { title, icon, loginImg, language } = storeToRefs(config)

// 国际化配置
const { locale } = useI18n()
const antLanguages = {
  zh_cn: zh_CN,
  zh_tw: zh_TW,
  en_us: en_US
}
const LOCAL = computed(() => {
  return antLanguages[language.value]
})
locale.value = language.value
dayjs.locale(language.value)
dayjs.extend(advancedFormat)
setLanguageHeader(language.value)
watch(
  language,
  async (val) => {
    setLanguageHeader(language.value)
    if (router.currentRoute.value.fullPath != '/') {
      // 刷新菜单
      const result = await getUinfoByToken()
    }
    router.go(0)
  },
  { immediate: false }
)

const getIcon = async () => {
  const result = await loadSimpleInfo()
  if (result) {
    title.value = result.platformName
    icon.value = QINIU_BASE_URL + result.icon
    loginImg.value = QINIU_BASE_URL + result.loginImg
    document.getElementById('showIcon').href = icon.value
    document.getElementById('showTitle').innerHTML = title.value
  }
  if (icon.value && title.value) {
    document.getElementById('showIcon').href = icon.value
    document.getElementById('showTitle').innerHTML = title.value
  }
}

onBeforeMount(async () => {})

onMounted(async () => {
  if (window.location.pathname == '/busi/') {
    getIcon()
  } else {
    document.getElementById('showIcon').href = icon.value
    document.getElementById('showTitle').innerHTML = title.value
  }
})
</script>
<style lang="less">
html,
body {
  margin: 0;
  width: 100vw;
  height: 100vh;

  -webkit-font-smoothing: antialiased; /* 字体抗锯齿渲染 */
}

#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}

/* 伪元素选择器修改基于 webkit 的浏览器的滚动条样式 */
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
  background: #3091f2;
  border-radius: 20px;
}
::-webkit-scrollbar-thumb:hover {
  background: #3091f2;
  width: 7px;
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
  border-radius: 20px;
}

.ant-layout {
  height: 100%;
  overflow: hidden;
}

.ant-layout-header {
  background-color: #fff;
  padding: 0 30px;
  height: auto;
}

.ant-layout-footer {
  background-color: #fff;
  padding: 0 30px;
  text-align: right;
}

.content {
  background-color: #fff;
  padding: 0 30px;
  overflow-x: auto;
}

.ant-page-header {
  padding: 16px 0 16px 0;
  user-select: none;
}

.unityFormItem {
  width: 216px !important;
}

.ant-btn + .ant-input-search,
.ant-btn + .ant-btn {
  margin-left: 20px;
}

.ADLButtonIcon {
  margin-right: 20px;
}

.ant-select-selector,
.ant-picker,
.ant-input-affix-wrapper,
.ant-input,
.ant-btn,
.ant-upload,
.ant-pagination-item-link,
.ant-pagination-item,
.ant-pagination-next,
.user-avatar {
  border-radius: @border-radius-base !important;
}

.tableSearch {
  display: grid;
  grid-template-columns: repeat(auto-fill, 290px);
  margin-top: 20px;
  justify-items: start;
  justify-content: space-between;
  grid-gap: 4px 24px;
  .ant-form-item {
    margin-bottom: 20px;
  }
  .ant-form-item:not(:last-child) {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    .ant-form-item-label {
      overflow: unset;
    }
    .ant-form-item-control {
      overflow: hidden;
    }
    .searchItem {
      width: 100%;
    }
  }
  .langSearchItem {
    grid-column-start: span 2;
  }
  .ant-form-item:last-child {
    grid-column-end: -1;
    margin-left: auto;
  }
}

// 返回按钮文本样式
.backButtonText {
  font-family: 'Microsoft YaHei UI';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height */
  letter-spacing: 0.05em;
  /* 主要文字 */
  color: #666666;
}

.form-upload-avatar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tooltip-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.ADL-form-step {
  text-align: end;
  padding-right: 12px;
  margin: 40px 0;
  position: relative;
  .ADL-form-step-context {
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    /* 强调文字 */
    color: #333333;
  }
  .ADL-form-step-tooltip {
    position: absolute;
    top: 2px;
    right: -10px;
  }
}

td .ant-btn-link {
  padding: 0;
}

.form-addOrEdit {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-top: 24px;
  .form-context {
    overflow-y: scroll;
    padding-right: 10px;
    margin-bottom: 10px;
  }
  .form-action {
    padding-right: 10px;
    height: 40px;
  }
  .modal-form-action {
    width: 100%;
    text-align: right;
    border-top: 1px solid #f0f0f0;
    margin-top: 16px;
    padding: 16px 24px 0 0;
  }
}

.modalForm {
  .ant-modal-body {
    padding: 24px 0;
    .content {
      padding: 0;
      .form-context {
        padding: 0 30px;
      }
    }
  }
}

.my-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  // background: #fff !important;
  .ant-table-wrapper {
    height: calc(100% - 65px);
    .ant-spin-nested-loading {
      height: 100%;
      .ant-spin-container {
        height: 100%;
        .ant-table {
          height: 100%;
          .ant-table-container {
            height: 100%;
          }
        }
      }
    }
  }
  .my-pagination {
    height: 65px;
    background-color: #fff;
    z-index: 99;
    .totalData {
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.05em;
      color: #919599;
    }
    .paginationButton {
      height: 32px;
      width: 32px;
      border-radius: 4px;
    }
  }
}

.ant-modal-content {
  border-radius: @border-radius-base;
  .ant-modal-confirm-title {
    max-width: calc(100% - 1.5rem);
    display: inline;
    line-height: 20px;
  }
  .ant-modal-confirm-content {
    margin-left: calc(1.2rem + 6px);
    margin-right: 5px;
    font-size: 14px;
    color: #666;
    white-space: pre-line;
  }
}

.ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {
  box-shadow: none;
}

.ant-table-ping-right {
  height: auto;
}

.fade-enter-active {
  transition: all 0.4s ease-out;
}

.fade-leave-active {
  transition: all 0.4s ease-out;
}

.fade-enter-from {
  opacity: 0;
  -webkit-transform: translate(-50px, 0);
  transform: translate(-50px, 0);
}
.fade-leave-to {
  opacity: 0;
  -webkit-transform: translate(50px, 0);
  transform: translate(50px, 0);
}

.uploadTip {
  color: gray;
  font-size: 16px;
  margin-top: 0.2rem;
}
</style>
